import { ErrorViewType } from 'features/v2a/receiver/helpers/V2A.helpers';
import { useTranslation } from 'react-i18next';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';

export interface ErrorMsgType {
  type: string;
  error: string;
  subtitle?: string;
  screenType?: ErrorScreenType;
}

export const useTranslatedError = () => {
  const { t: translatedText } = useTranslation('moveMoney', {
    keyPrefix: 'errorMsg',
  });

  const getErrorMessage = (key: string): ErrorMsgType => {
    const errorMessages: Record<string, ErrorMsgType> = {
      INVALID_CARD_NUMBER: {
        type: ErrorViewType.INLINE,
        error: translatedText('invalidCard.error'),
      },
      INVALID_CARD: {
        type: ErrorViewType.INLINE,
        error: translatedText('invalidCard.error'),
      },
      INVALID_CVV: {
        type: ErrorViewType.INLINE,
        error: translatedText('invalidCvv.error'),
      },
      INVALID_ZIP: {
        type: ErrorViewType.INLINE,
        error: translatedText('invalidZip.error'),
      },
      INVALID_EXPIRY: {
        type: ErrorViewType.INLINE,
        error: translatedText('invalidExpiry.error'),
      },
      RETRY_LATER_ERROR: {
        type: ErrorViewType.TERMINAL,
        error: translatedText('retryLaterError.error'),
        subtitle: translatedText('retryLaterError.subtitle'),
        screenType: ErrorScreenType.Error,
      },
      ILLEGAL_STATE: {
        type: ErrorViewType.TERMINAL,
        error: translatedText('illegalState.error'),
        subtitle: translatedText('illegalState.subtitle'),
        screenType: ErrorScreenType.Error,
      },
      TERMINAL_ERROR: {
        type: ErrorViewType.TERMINAL,
        error: translatedText('terminalError.error'),
        subtitle: translatedText('terminalError.subtitle'),
        screenType: ErrorScreenType.Error,
      },
      BAD_TOKEN: {
        type: ErrorViewType.TERMINAL,
        error: translatedText('badToken.error'),
        subtitle: translatedText('badToken.subtitle'),
        screenType: ErrorScreenType.Error,
      },
      RISK_REVIEW_ERROR: {
        type: ErrorViewType.TERMINAL,
        error: translatedText('riskReviewError.error'),
        subtitle: translatedText('riskReviewError.subtitle'),
        screenType: ErrorScreenType.Error,
      },
    };

    const unknownError = {
      type: ErrorViewType.TERMINAL,
      error: translatedText('unknownError.error'),
      screenType: ErrorScreenType.Error,
    };

    const errorMessage = errorMessages[key] || unknownError;
    errorMessage.screenType = errorMessage.screenType || ErrorScreenType.Error;
    return errorMessage;
  };

  return { getErrorMessage };
};
